import { DiffQueries } from './components/VisualBuildDetailsPage';

export const TRACK_USER_HAS_VISITED_VISUAL = 'TRACK_USER_HAS_VISITED_VISUAL';
export const VISUAL_USER_EVENTS = {
  hasVisitedVisualBuild: 'hasVisitedVisualBuild',
  hasVisitedVisualBuildIndex: 'hasVisitedVisualBuildIndex',
};

export const urls = {
  getDiff: (buildId: string, stepId?: string, query?: DiffQueries) => {
    const search = query ? `?${new URLSearchParams(query).toString()}` : '';

    return `/visual/builds/${buildId}${stepId ? `/step/${stepId}` : ''}${search}`;
  },
  getBuilds: (pageNumber?: string) => `/visual/builds${pageNumber ? `?page=${pageNumber}` : ''}`,
};
